import React, { useState } from 'react';
import {
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from '@mui/material';
import { SavedList } from '../../types';
import { SavedListCard } from './SavedListCard';

interface SavedListsProps {
  lists: SavedList[];
  onLoadList: (list: SavedList) => void;
  onDeleteList: (listId: number) => void;
}

export const SavedLists: React.FC<SavedListsProps> = ({
  lists,
  onLoadList,
  onDeleteList,
}) => {
  const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
  const [selectedList, setSelectedList] = useState<SavedList | null>(null);

  const handleDeleteClick = (list: SavedList) => {
    setSelectedList(list);
    setDeleteConfirmOpen(true);
  };

  const handleConfirmDelete = () => {
    if (selectedList) {
      onDeleteList(selectedList.id);
    }
    setDeleteConfirmOpen(false);
    setSelectedList(null);
  };

  return (
    <>
      <Grid container spacing={2}>
        {lists.map(list => (
          <Grid item xs={12} sm={6} md={4} key={list.id}>
            <SavedListCard
              list={list}
              onLoadList={onLoadList}
              onDeleteList={onDeleteList}
              onDeleteClick={handleDeleteClick}
            />
          </Grid>
        ))}
      </Grid>

      <Dialog open={deleteConfirmOpen} onClose={() => setDeleteConfirmOpen(false)}>
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogContent>
          Are you sure you want to delete the list "{selectedList?.name}"?
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDeleteConfirmOpen(false)}>Cancel</Button>
          <Button onClick={handleConfirmDelete} color="error" variant="contained">
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default SavedLists;
